import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { syncPartnerAudiencesAudience } from 'scenes/CustomAudiences/Audiences/sources/partnerAudiences';
import BatchItemsList from 'scenes/CustomAudiences/components/BatchItemsList';

import { syncPartner } from '../queryKeyFactory';

export const useSyncPartnerAudiencesAudience = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const syncAUMutation = useMutation(
    syncPartner(),
    syncPartnerAudiencesAudience,
    {
      successMessage: () => `Partner Audiences was synced`,
    }
  );

  const handleAction = async ({ audience, name, partnerAudiences }) => {
    await showModal({
      title: `Sync Partner Audiences?`,
      confirmActionLabel: 'Sync',
      children: partnerAudiences ? (
        <BatchItemsList data={partnerAudiences} />
      ) : null,
    });
    await syncAUMutation.mutateAsync({ audience, name });
  };

  return [handleAction, syncAUMutation];
};
